import { Component, OnInit } from '@angular/core';
import { ApiPartnerService } from '@app/api/api-partner.service';
import { ExcelServicesService } from '@app/_services/excel-service.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'app-reportpartner',
  templateUrl: './reportpartner.component.html',
  styleUrls: ['./reportpartner.component.css']
})
export class ReportpartnerComponent implements OnInit {

  PartnerList: any = {};
  excel=[];
  table_load = false;
  table_data = false;
  first_index : number;
  last_index: number;
  total_count: number;
  querySearch = false;
  queryParams = '';
  msearch : string;
  currentParams = {};
  paging : any = {};
  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  searchQueryParams = '';

  constructor(
    public partnerService: ApiPartnerService,
    private excelService:ExcelServicesService,
    private route: ActivatedRoute) {
      this.partnerService.GetReportPartner().subscribe(data => {
        data.data.forEach(row => {
          this.excel.push(row);
        });
      });
    }

  ngOnInit() {
    this.loadReportPartner();
    this.route.queryParams
      //.filter(params => params.order)
      .subscribe(params => {
        // console.log(params); // {order: "popular"}

        //this.order = params.order;
        //console.log(this.order); // popular

        if (params.search != '' && params.search != undefined ){
          console.log('search');
          console.log(params.search);
         this.msearch = params.search; 
         this.querySearch = true;
        

         this.currentParams = params;
         this.queryParams = '?'+this.queryStr(params);
         this.loadReportPage(this.queryParams);
        
        }else{
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = '?'+this.queryStr(params);
          // console.log(this.queryParams);
          // console.log(this.queryStr(params));
          /* pagination */
          //this.loadworkorder(this.currentParams);
          this.loadReportPage(this.queryParams);
        }
      });
  }

  queryStr(options){
    let params = new URLSearchParams();
    for(let key in options){
        params.set(key, options[key]) 
    }
    return params.toString();
  }

  search() {
    this.querySearch = true;
    this.searchQueryParams = this.queryParams+'&search='+this.msearch;
    this.loadReportPage(this.searchQueryParams);
  }

  loadReportPage(params){
    this.table_load = true;
    return this.partnerService.GetReportPage(params).subscribe((output: any) => {
    // console.log(output);
      this.PartnerList = output;

      this.table_load = false
      this.table_data = true

      this.paging = this.PartnerList.pagex;
      this.page_self = this.PartnerList.pagex.self;
      this.page_next = this.PartnerList.pagex.next;
      this.page_prev = this.PartnerList.pagex.prev;
      this.meta = this.PartnerList.meta;
      this.total_count = this.meta['totalCount'];
      let self = this.page_self['page'];
      if ( self * this.meta['perPage'] < this.meta['totalCount']){
        this.last_index = (self * this.meta['perPage']);
      }else{
        this.last_index = this.meta['totalCount'];
      }
      
      this.first_index = ((self-1)*this.meta['perPage'])+1;
    })
  }
    
  loadReportPartner() {
    this.table_load = true;

    return this.partnerService.GetReportPartner().subscribe((output: {}) => {
      // console.log(output);
      this.PartnerList = output;
      this.table_load = false
      this.table_data = true
    })
  }

  exportAsXLSX():void {
    this.excelService.exportAsExcelFile(this.excel, 'Data Partner');
  }
}
